import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Sale } from '../sale';
import { Subscription } from 'rxjs/Subscription';
import { Branch } from '../../accounting/branch';
import { Customer } from '../../accounting/customer';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common'; import { Piece } from '../../inventory/piece';
import { CustomerService } from '../../accounting/customer/customer.service';
import { ReportService } from '../../../shared/services/report.service';
import { ITdDataTableColumn, TdDataTableSortingOrder, TdLoadingService, TdDataTableService, TdDialogService, ITdDataTableSortChangeEvent, IPageChangeEvent } from '@covalent/core';
import { SalesService } from '../sales.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { SettingsService } from '../../../shared/services/settings.service';
import { BranchService } from '../../accounting/branches/branch.service';
import { InventoryService } from '../../inventory/inventory.service';
import { PoService } from '../../purchasing/pos/po.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { PoBranch } from '../../purchasing/pos/poBranch';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.scss'],
  providers: [CustomerService, ReportService]
})
export class RefundComponent implements OnInit {
  _loading: number = 0;
  _selectAll: boolean;

  data: Sale;
  currentSale: Sale = new Sale();

  originalSale: Sale = new Sale();

  valid_salesmen: string[] = [];

  subscription: Subscription = new Subscription();
  title: string;

  allBranches: Branch[];
  filteredBranches: Branch[];
  allCustomers: Customer[];
  filteredCustomers: Customer[];

  availableStatuses: string[];

  allTypes$: Observable<string[]>;
  isEditMode: boolean;
  refundMode: boolean = false;

  existingInventory: Piece[];

  totalPiecesValue: number = 0;
  totalQtyValue: number = 0;
  totalValue: number = 0;
  totalMetersValue: number = 0;
  totalPriceByRowValue: number = 0;
  totalPriceByAllRowsValue: number = 0;
  discount: number = 10;
  shippingCharges: number = 100;
  totals: number = 0;
  totalUnitPrices: number = 0;
  allCollections$: Observable<string[]>;
  allDesignColors$: Observable<string[]>;

  columns_existing: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'pieceNo', label: 'Piece #' },
    { name: 'lotNo', label: 'Lot #' },
    { name: 'grade_code', label: 'Grade' },
    { name: 'length', label: 'Length (M)' },
    { name: 'weight', label: 'Weight (Kg)' },
    { name: 'original_price', label: 'Price Sold' }
  ];

  columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'pieceNo', label: 'Piece #' },
    { name: 'lotNo', label: 'Lot #' },    
    { name: 'grade_code', label: 'Grade' },
    { name: 'quantity', label: 'QTY (M)' },
    { name: 'unit_price', label: 'Unit Price' },
  ];

  // Selected Items
  items: Piece[] = [];

  // Current Inventory
  filteredData: any[] = [];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  // Currency Symbol for displays
  _currency_symbol: string;

  constructor(private _salesService: SalesService,
    private _customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private _dataTableService: TdDataTableService,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    private _branchService: BranchService,
    private _inventoryService: InventoryService,
    private _reportService: ReportService,
    private _poService: PoService,
    private location: Location,
    public _authService: AuthenticationService) { }

  ngOnInit(): void {
    this.setLoading(true, 'loading');

    this.route.paramMap
      .switchMap((params: ParamMap) => params.get('id')
        ? this.processEditRefund(params.get('id'))
        : this.processNewRefund())
      .subscribe((currentItem: Sale) => {
        this.currentSale = currentItem;
        // If it was an existing Sale retrieve items
        if (this.currentSale.id != null) {
          this.title = this.currentSale.order_number;

          this.originalSale = Object.assign({}, this.currentSale);

          this._salesService.getRefundItems(this.currentSale.id + '').subscribe(
            response => {
              this.items = response;

              this.items.forEach(
                item => {
                  item.unit_price == item.original_price;
                }
              )
              this.filter();
            }
          );

          this.updateInventory();
        } else {
          // This one's new. Set default branch on load
          this.currentSale.branch_id = this._authService.getHomeBranch();
          // And its tax
          this.updateTax(this.currentSale.branch_id);
        }

        this.setLoading(false, 'loading');
        this.availableStatuses = this.getAvailableStatuses();

        this.filterSalesmen();
      });


    this._salesService.getCustomerPrefixes().subscribe(
      response => {
        this.allCustomers = response;
        this.filteredCustomers = response;
      }
    );
    this.availableStatuses = this.getAvailableStatuses();

    this.allTypes$ = this._salesService.getTypes();


    this.allBranches = this._authService.getUserBranches();
    this.filteredBranches = this.allBranches;
  }

  filterSalesmen() {
    console.log(this.currentSale.branch_id);
    this._salesService.getUsersPerBranch(this.currentSale.branch_id + '').subscribe(
      response => {
        if (Array.isArray(response)) {
          this.valid_salesmen = response.map(i => i.first_name + ' ' + i.last_name);
        } else {
          this.valid_salesmen = [];
        }
      }
    );
  }

  customerOptions(search: string) {
    return (this.filteredCustomers || []).filter(value => (value.name || '').toLowerCase().indexOf((search || '').toLowerCase()) === 0);
  }

  filterCustomers() {
    this._customerService.getCustomersPerBranch(this.currentSale.branch_id + '').subscribe(
      (response: { id: string, customers: Customer[] }) => {
        this.filteredCustomers = response.customers.filter(
          (c: Customer) => {
            return this.allCustomers.some(
              (_c: Customer) => {
                return c.id == _c.id
              }
            );
          }
        );
      }
    );
  }

  filterBranches() {
    this._customerService.getOneCustomerBranches(this.currentSale.customer_id + '').subscribe(
      (response: { id: string, branches: Branch[] }) => {
        this.filteredBranches = response.branches.filter(
          (b: Branch) => {
            return this.allBranches.some(
              (_b: Branch) => {
                return b.id == _b.id
              }
            )
          }
        );
      }
    );
  }

  setLoading(loading: boolean, name: string) {
    if (loading) {
      this._loadingService.register(name);
      this._loading ++;
    }
    else {
      this._loadingService.resolve(name);
      this._loading --;
    }
  }

  isLoading() : boolean {
    return this._loading > 0;
  }

  updateInventory() {
    this._inventoryService.getSoldPieces(this.currentSale.customer_id).subscribe(
      response => {
        this.existingInventory = response;
        this.filter();
      }
    );
  }

  updateTax($event) {
    this._branchService.getBranch($event).subscribe(
      response => {
        if (response.sales_tax != null) {
          this.currentSale.tax = response.sales_tax;
        }
        if (response.sales_tax2 != null) {
          this.currentSale.tax2 = response.sales_tax2;
        }
        // Update also the currency
        if (response.currency != null) {
          this._currency_symbol = response.currency;
        }
      }
    );
  }

  changed(): boolean {
    for (let prop in this.currentSale) {
      if (this.currentSale[prop] != this.originalSale[prop]) {
        return true;
      }
    }

    return false;
  }

  getSalesman($event) {
    this._customerService.getOneCustomer($event).subscribe(
      response => {
        this.currentSale.salesman = response.sales_person;
      }
    );
  }

  total(data: any[], field: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field]) }, 0);
  }

  totalProduct(data: any[], field1: string, field2: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + (Number.parseFloat(b[field1]) * Number.parseFloat(b[field2])) }, 0);
  }

  totalChecked(data: any[], field: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b['selected'] ? b[field] : 0) }, 0);
  }

  toggleSelectAll(value: boolean) {
    this.filteredData.forEach(
      function (d) {
        d.selected = value;
      }
    );
  }

  shouldSelectAll(): boolean {
    return this.filteredData.filter(
      function (d) {
        return d.selected
      }
    ).length == this.filteredData.length;
  }

  addItemsToOrder(items) {
    this.filteredData.forEach(
      (i) => {
        if (i.selected) {
          this.items.push(i);

          // Default the quantity to the whole length
          i.quantity = i.length;

          i.unit_price = -i.original_price;

          i.selected = false;

          this._selectAll = false;
        }
      }
    );
    // Order items alphabetically
    this.items = this.items.sort(
      (a, b) => {

        // ignore collection on sort, only design then color
        return (a['design_name'] != b['design_name']) ?
          ((a['design_name'] > b['design_name']) ? 1 : -1) :
          ((a['color_name'] > b['color_name']) ? 1 : -1);
      }
    );

    this.filter();
  }

  removeItem(id: number) {
    this.items = this.items.filter(
      (t) => {
        if (t.id == id) {

          return false;
        } else {
          return true;
        }
      });

    this.filter();
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.existingInventory ? this.existingInventory : [];
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    // Do not display in the inventory the stuff that has been added already
    this.items.forEach(
      (i) => {
        newData = newData.filter((d) => { return d.id != i.id });
      }
    );

    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    // Sort the inventory based on design/color
    this.filteredData = newData.sort(
      (a, b) => {
        return (a['design_name'] != b['design_name']) ?
          ((a['design_name'] > b['design_name']) ? 1 : -1) :
          ((a['color_name'] > b['color_name']) ? 1 : -1);
      }
    );

  }

  openModifyTax1() {
    this._dialogService.openPrompt({
      message: 'Enter new VAT value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: this.currentSale.tax + '',
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        this.currentSale.tax = Number.parseFloat(newValue);
      } else {
        console.log('No change');
      }
    });
  }

  openModifyTax2() {
    this._dialogService.openPrompt({
      message: 'Enter new QST value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: this.currentSale.tax2 + '',
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        this.currentSale.tax2 = Number.parseFloat(newValue);
      } else {
        console.log('No change');
      }
    });
  }

  enterNewValueDialog(row: Piece, attr: string) {
    this._dialogService.openPrompt({
      message: 'Enter new value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: row[attr],
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        let this_piece = this.existingInventory.find((i) => { return i.id == row.id });

        let maxValue: number = this_piece ? (attr == 'quantity' ? this_piece.length : -9999999999) : 999999999;

        console.log(newValue, maxValue);
        let valid: boolean = (attr == 'quantity') ?
          (Number.parseFloat(newValue) > 0 && Number.parseFloat(newValue) <= maxValue) :
          (Number.parseFloat(newValue) > maxValue && Number.parseFloat(newValue) < 0);

        if (valid) {
          row[attr] = newValue;
        } else {
          this._dialogService.openAlert({
            message: 'Invalid value. The value should be between 0 and ' + maxValue,
            title: 'Failed!',
          });
        }
      } else {
        console.log('DECLINED');
      }
    });
  }

  processEditRefund(orderNumber: string): Observable<Sale> {
    this.title = 'Edit';
    this.isEditMode = true;
    return this._salesService.getOneRefund(orderNumber);
  }

  processNewRefund(): Observable<Sale> {
    this.title = 'New';
    this.isEditMode = false;
    return Observable.of(new Sale());
  }

  createNewRefundOrder() {
    this.setLoading(true, 'loading');

    if (!this.currentSale.order_date || !this.currentSale.delivery_date) {
      this._dialogService.openAlert({
        title: 'Missing Data',
        message: "Please Enter an Order Date and Delivery Date",
        closeButton: 'OK'
      })

      this.setLoading(false, 'loading');
      return;
    }

    // Clean slate
    this.currentSale.items = [];
    this.items.forEach(
      (item) => {
        this.currentSale.items.push({
          id: item.id,
          quantity: item.quantity,
          unit_price: item.unit_price
        });
      }
    );
    // Create the refund
    this._salesService.createRefund(this.currentSale).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.currentSale.id = response['id'];
          this.currentSale.order_number = response['order_number'];

          this.originalSale = Object.assign({}, this.currentSale);

          this.isEditMode = true;
          this._dialogService.openAlert({
            message: 'Return Order ' + this.currentSale.order_number + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/refunds', 'list']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not create Return Order ' + this.currentSale.order_number + '.',
            title: 'Failed!',
          });
        }

        this.setLoading(false, 'loading');
      },
      error => {
        this._dialogService.openAlert({
          message: 'Error creating Sales Order ' + this.currentSale.order_number + ': ' + error,
          title: 'Error!',
        });
        this.setLoading(false, 'loading');

      },
      () => { }
    );
  }

  updateRefundOrder() {
    this.setLoading(true, 'loading');

    // Clean slate
    this.currentSale.items = [];
    this.items.forEach(
      (item) => {
        this.currentSale.items.push({
          id: item.id,
          quantity: item.quantity,
          unit_price: item.unit_price
        });
      }
    );

    this._salesService.updateRefund(this.currentSale.id, this.currentSale).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.originalSale = Object.assign({}, this.currentSale);

          this._dialogService.openAlert({
            message: 'Return Order ' + this.currentSale.order_number + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/refunds', 'list']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not update Return Order ' + this.currentSale.order_number + '.',
            title: 'Failed!',
          });
        }

        this.setLoading(false, 'loading');

      },
      error => {
        this._dialogService.openAlert({
          message: 'Error updating Return Order ' + this.currentSale.order_number + ': ' + error,
          title: 'Error!',
        });
        this.setLoading(false, 'loading');

      },
      () => { }
    );
  }



  // getPrefixForCustomerId(id: number) {
  //   this.currentSale.customer_prefix = this.allCustomers.find(
  //     (c) => {
  //       return Number.parseInt(c.id) == id;
  //     }
  //   )['prefix'];
  // }

  getPrefixForCustomerName(name: string) {
    let customer = this.allCustomers.find(
      (c) => {
        return c.name == name;
      }
    );

    if (customer) {
      this.currentSale.customer_id = Number.parseInt(customer.id);
      this.currentSale.customer_prefix = customer.prefix;

      // And get other stuff too
      this.getSalesman(this.currentSale.customer_id);
      this.filterBranches();
    }
  }

  refund() {
  }

  goBack(): void {
    this.location.back();
  }

  getAvailableStatuses(): string[] {
    // On new entry only DRAFT
    if (this.isEditMode == false) {
      return ['DRAFT', 'CONFIRMED'];
    }

    switch (this.currentSale.status) {
      // If it was draft, can be DRAFT, RESERVED
      case 'DRAFT':
        return ['DRAFT', 'CONFIRMED', 'CANCELLED'];

      // Else you can't move status in here
      default:
        return [this.currentSale.status];
    }

  }

  isDraft(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'CONFIRMED':
      case 'CANCELLED':
        return true;
      default:
        return false;
    }
  }

  isConfirmed(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'CANCELLED':
        return false;
      case 'CONFIRMED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }

  wasConfirmed(): boolean {
    if (this.originalSale == null) return false;

    switch (this.originalSale.status) {
      case 'DRAFT':
      case 'CANCELLED':
        return false;
      case 'CONFIRMED':
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }


  isCancelled(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'CONFIRMED':
        return false;
      case 'CANCELLED':
        return true;
      default:
        return false;
    }
  }


  isReceived(): boolean {
    if (this.currentSale == null) return false;

    switch (this.currentSale.status) {
      case 'DRAFT':
      case 'CONFIRMED':
      case 'CANCELLED':
        return false;
      case 'RECEIVED':
        return true;
      default:
        return false;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/sales/refund/refund.component.ts